import React from "react";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";

const Radial = ({ graphOptions, dataTestId }) => {
  const { options, series } = graphOptions;

  return (
    <div data-test-id={dataTestId} className="chart-item">
      <Chart
        options={options}
        series={series}
        type="radialBar"
        width={options.width}
        height={options.height}
      />
    </div>
  );
};

Radial.propTypes = {
  graphOptions: PropTypes.shape({
    options: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    series: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  dataTestId: PropTypes.string,
};

Radial.defaultProps = {
  dataTestId: PropTypes.isNull,
};

export default Radial;
